export class Docker {
    public nombre: string;
    public imagen: string;
    public link: string;
    public permiso: string;
    public selected: boolean;

    constructor(nombre: string,
                imagen: string,
                link: string,
                selected: boolean,
                permiso: string) {

        this.nombre = nombre;
        this.imagen = imagen;
        this.permiso = permiso;
        this.link = link;
        this.selected = selected;
    }
}


// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/recursos/modelo/docker.ts